import { cn } from '@/lib/shadcn/lib/utils';

export function BonusIconLight({ className }: { className?: string }) {
  return (
    <svg
      className={cn(className)}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 16C0 7.163 7.163 0 16 0h12c8.837 0 16 7.163 16 16v12c0 8.837-7.163 16-16 16H16C7.163 44 0 36.837 0 28V16z"
        fill="#FFF3E9"
      />
      <path
        d="M36.202 34.324l-.445 1.373c-.644.05-1.126.075-1.448.075-1.485 0-2.698-.631-3.638-1.894-.916-1.237-1.374-2.858-1.374-4.863 0-1.213.272-3.502.817-6.868.57-3.39 1.225-6.485 1.967-9.281.149-.62.223-1.027.223-1.226 0-.197-.086-.296-.26-.296-.173 0-.73.928-1.67 2.784a419.33 419.33 0 00-3.304 6.794 653.042 653.042 0 01-2.228 4.603c-.173.372-.322.68-.445.928-.1.223-.322.644-.669 1.263a27.81 27.81 0 01-.928 1.596c-.817 1.237-1.46 1.856-1.93 1.856-.322 0-.68-.086-1.077-.26-.371-.173-.619-.359-.742-.556-.273-.421-.409-1.733-.409-3.936 0-4.603.372-8.996 1.114-13.18.247-1.385.371-2.115.371-2.19 0-.247-.099-.37-.297-.37-.396 0-1.027 1.237-1.893 3.712l-1.077 3.081c-1.584 4.48-3.192 7.97-4.826 10.47-1.609 2.5-3.465 4.256-5.569 5.271L5.5 31.168c2.4-1.782 4.245-3.6 5.532-5.457 1.311-1.856 2.735-4.851 4.269-8.984l1.262-3.379c.867-2.351 1.621-4.022 2.265-5.012.643-1.014 1.361-1.522 2.153-1.522 1.312 0 1.968.792 1.968 2.376 0 .124-.235 2.636-.706 7.537-.47 4.875-.705 8.093-.705 9.652 0 .446.074.68.223.705.123 0 .26-.123.408-.37 2.005-3.342 3.923-6.98 5.755-10.915l1.15-2.562a43.86 43.86 0 011.597-3.23c.52-.94.916-1.51 1.188-1.708.272-.223.705-.334 1.3-.334.593 0 1.1.223 1.521.668.446.421.669.929.669 1.523 0 .593-.087 1.274-.26 2.041-1.93 9.43-2.896 15.073-2.896 16.93 0 1.83.297 3.08.89 3.749.595.693 1.634 1.176 3.12 1.448z"
        fill="#FF861A"
      />
    </svg>
  );
}
